import { Flex, Text, VStack } from '@chakra-ui/core';
import { CheckIcon, WarningIcon } from '@chakra-ui/icons';
import React from 'react';

export interface InfoValidation {
  label: string;
  valid: boolean;
}
interface InfoValidationStackProps {
  validations: InfoValidation[];
}

const InfoValidationStack = ({ validations }: InfoValidationStackProps) => {
  return (
    <VStack w="fit-content" alignItems="initial" spacing={1}>
      {validations.map(({ label, valid }) => (
        <Flex alignItems="center" justifyContent="initial">
          {valid ? (
            <CheckIcon
              color="white"
              boxSize="14px"
              backgroundColor="blue.600"
              borderRadius="100px"
              mr={1}
              p="4px"
            />
          ) : (
            <WarningIcon color="red.500" boxSize="14px" mr={1} />
          )}

          <Text fontSize="xs">{label}</Text>
        </Flex>
      ))}
    </VStack>
  );
};

export default InfoValidationStack;
